<script lang="ts">
  import type { HostConfig } from '$lib/types';

  export let locals: HostConfig;
</script>

<svelte:head>
  <title>{locals?.title}</title>
  <link rel="icon" href={locals?.favicon} type="image/x-icon" />
  <meta name="description" content={locals?.description} />
  <link rel="canonical" href={locals?.og_url} />
  <meta property="og:title" content={locals?.og_title} />
  <meta property="og:description" content={locals?.og_description} />
  <meta property="og:url" content={locals?.og_url} />
  <meta property="og:site_name" content={locals?.og_site_name} />
</svelte:head>
